module.exports = __webpack_public_path__ + "resources/img/img_datahunt3_m_jp.f7b26898b06950eff89a14c201984914.png";